import { GetServerSideProps } from "next";
import { getLocale } from "lib/localization";
import { getStaticPropsGetter } from "components/category-page-next/tag-server-methods";
import { getGeoCountry } from "lib/get-geo-country";
import { checkTagExists } from "lib/api";
import { trackClick } from "lib/api/track-click";

export { default } from "components/the-buzz-theme/page/tag";
export const getServerSideProps: GetServerSideProps = async function ({
  req,
  params,
}) {
  const lang = getLocale(req);

  if (!params?.tag) {
    return {
      notFound: true,
    };
  }

  const { tag } = await checkTagExists(
    typeof params.tag === "string" ? params.tag : params.tag[0],
  );

  if (tag === null) {
    return {
      notFound: true,
    };
  }

  trackClick(req.headers, req.url, lang);

  const getStaticPropsCall = getStaticPropsGetter(tag?.slug || "");

  const { props } = await getStaticPropsCall({ params: { lang } });

  return {
    props: {
      geoIpCountry: getGeoCountry(req),
      tag: tag?.slug,
      ...props,
    },
  };
};
